import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "./ui";

const NAV = [
  { to: "/app", label: "Overview", end: true },
  { to: "/app/fleet", label: "Fleet" },
  { to: "/app/pilots", label: "Pilots" },
  { to: "/app/missions", label: "Missions" },
  { to: "/app/sessions", label: "Devices" },
  { to: "/app/settings", label: "Settings" },
];

export function AppShell() {
  const auth = useAuth();
  const navigate = useNavigate();
  if (auth.status !== "authenticated") return null;

  return (
    <div className="min-h-full flex flex-col">
      <header className="sticky top-0 z-10 border-b border-rule-soft bg-panel/85 backdrop-blur-xl">
        {/* Two rows below lg: brand and sign out on top, the nav under it. Phones get the six items in a grid; wider screens a row that scrolls inside itself rather than widening the page. */}
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-2 lg:py-0 lg:h-16 flex flex-wrap lg:flex-nowrap items-center gap-x-8 gap-y-1">
          <div className="flex items-center gap-2.5 order-1">
            <span className="grid place-items-center w-9 h-9 rounded-full bg-accent shrink-0">
              <img src="/brand/firefly-mark.png" alt="" className="w-[88%] h-[88%] object-contain" />
            </span>
            <span className="text-[1.15rem] font-bold tracking-tight">FireFly</span>
            <span className="text-[1.15rem] font-semibold text-ink-soft">Fleet</span>
          </div>

          <nav className="order-3 lg:order-2 w-full lg:w-auto lg:flex-1 -mx-1 px-1 grid grid-cols-3 gap-0.5 sm:flex sm:items-center sm:gap-1 sm:overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `text-[0.9rem] sm:text-[0.95rem] font-semibold px-1.5 sm:px-3.5 h-9 shrink-0 inline-flex items-center justify-center rounded-lg transition-colors ${
                    isActive ? "bg-accent/20 text-accent-text" : "text-ink-soft hover:text-ink hover:bg-panel-raised"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="order-2 lg:order-3 ml-auto lg:ml-0 flex items-center gap-4">
            <div className="text-right hidden xl:block leading-tight">
              <p className="text-[0.95rem] font-semibold text-ink">{auth.me.organization.name}</p>
              <p className="text-[0.85rem] text-ink-soft">{auth.me.user.email}</p>
            </div>
            <Button
              variant="secondary"
              className="h-9 px-4 shrink-0 whitespace-nowrap"
              onClick={async () => {
                await auth.signOut();
                navigate("/login", { replace: true });
              }}
            >
              Sign out
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-6xl px-4 sm:px-6 py-8 sm:py-10">
        <Outlet />
      </main>
    </div>
  );
}
